import { NgModule } from '@angular/core';
import { DayOfMonthPipe } from './day-of-month';

@NgModule({
  declarations: [
    DayOfMonthPipe
  ],
  imports: [ ],
  exports: [
    DayOfMonthPipe
  ]
})
export class DayOfMonthModule {}



// WEBPACK FOOTER //
// ./src/pipes/day-of-month/day-of-month.module.ts